import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Dec 31 2019
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
export var DPDefaultTreeNode =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPDefaultTreeNode, _DomainObject);

  function DPDefaultTreeNode(path, name, attempts, timeout) {
    var _this;

    _classCallCheck(this, DPDefaultTreeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPDefaultTreeNode).call(this));
    _this.path = path;
    _this.name = name;
    _this.attempts = attempts;
    _this.timeout = timeout;
    return _this;
  }

  return DPDefaultTreeNode;
}(DomainObject);